// Bottle Image Switcher
document.addEventListener('DOMContentLoaded', function() {
  function setupBottleImageSwitcher() {
    // Find the bottle selection cards
    const bottleCards = document.querySelectorAll('.JB-bottle-card');
    if (bottleCards.length === 0) return false;
    
    // CONFIGURATION: Set your image identifiers here with your provided filenames
    const bottleImageIdentifiers = {
      'standard-bottle': 'jb_starterset_produkbilder_06_set_uebersicht_Kopie_f77fe6b3-a097-448f-9faf-7ef525fc8680',
      'premium-bottle': 'jb_premium_starterset_produktbilder_Kopie_1'
    };
    
    // Add click handlers to each bottle card
    bottleCards.forEach(card => {
      card.addEventListener('click', function() {
        // Get the bottle type value from the hidden input
        const bottleType = this.querySelector('input[type="text"]').value;
        const imageIdentifier = bottleImageIdentifiers[bottleType];
        
        if (!imageIdentifier) return;
        
        // Find the media carousel in the product gallery
        const mediaCarousel = document.querySelector('media-carousel');
        if (!mediaCarousel) return;
        
        // Find all media items (slides) in the carousel
        const mediaItems = mediaCarousel.querySelectorAll('.product-gallery__media');
        
        // Find the matching image slide by checking if src contains our identifier
        for (let i = 0; i < mediaItems.length; i++) {
          const img = mediaItems[i].querySelector('img');
          if (img && img.src.includes(imageIdentifier)) {
            // Use the carousel's select method to switch to this slide
            mediaCarousel.select(i);
            break;
          }
        }
      });
    });
    
    // Set initial state based on which card is active when page loads
    const activeCard = document.querySelector('.JB-bottle-card.active');
    if (activeCard) {
      const bottleType = activeCard.querySelector('input[type="text"]').value;
      const imageIdentifier = bottleImageIdentifiers[bottleType];
      
      if (imageIdentifier) {
        const mediaCarousel = document.querySelector('media-carousel');
        if (mediaCarousel) {
          const mediaItems = mediaCarousel.querySelectorAll('.product-gallery__media');
          for (let i = 0; i < mediaItems.length; i++) {
            const img = mediaItems[i].querySelector('img');
            if (img && img.src.includes(imageIdentifier)) {
              mediaCarousel.select(i);
              break;
            }
          }
        }
      }
    }
    
    return true;
  }
  
  // Try to set up immediately, or wait and retry if elements aren't loaded yet
  if (!setupBottleImageSwitcher()) {
    const checkInterval = setInterval(function() {
      if (setupBottleImageSwitcher()) {
        clearInterval(checkInterval);
      }
    }, 500);
  }
});